var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-ons-splitter',[_c('v-ons-splitter-side',{attrs:{"swipeable":"","side":"left","collapse":"","width":"80%","animation":_vm.md ? 'overlay' : 'reveal',"swipe-target-width":_vm.md && 25,"open":_vm.isOpen},on:{"update:open":function($event){_vm.isOpen=$event}}},[_c('Menu')],1),_c('v-ons-splitter-content',[_c('Home')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }